module.exports = __webpack_public_path__ + "static/img/6.b9425a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/6.png
// module id = +12J
// module chunks = 4